<div class="position-balance-wks-component" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <span>{{ title }}</span>
    <div class="icons gridster-ignore-drag">
      <mat-icon disableWksChange svgIcon="close" (click)="removeItemFromWorkspace()" matTooltipPosition="above"
        [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="container gridster-ignore-drag">
    <ng-container *ngIf="loading; else elseTemplate">
      <div class="row line spinner">
        <div class="col-12 center">
          <app-spinner-loading></app-spinner-loading>
        </div>
      </div>
    </ng-container>
    <ng-template #elseTemplate>
      <div class="box-offline" *ngIf="!account">
        <span>{{ msgOfflineNegotiation }}</span>
      </div>
      <div class="box-online" *ngIf="account">
        <div class="row line bg">
          <div class="">Saldo C/C</div>
          <div class="">{{ financialAccount.availableBalance ?
            (financialAccount.availableBalance | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
          </div>
        </div>
        <div class="row line">
          <div class="custom-tooltip">
            <span>Saldo Projetado</span>
            <app-custom-tooltip class="pos-abs" position="TOP_LEFT">
              <div custom-tooltip-content>
                <ng-container *ngTemplateOutlet="balanceProjOnlineDetail"></ng-container>
              </div>
            </app-custom-tooltip>
          </div>
          <div class="">
            {{ financialAccount.balanceProjOnline ?
            (financialAccount.balanceProjOnline | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
          </div>
        </div>
        <div class="row line bg">
          <div class="custom-tooltip">
            <span>Limite Operacional</span>
            <app-custom-tooltip class="pos-abs" position="TOP_LEFT">
              <div custom-tooltip-content>
                <ng-container *ngTemplateOutlet="uniqueLimitDetail"></ng-container>
              </div>
            </app-custom-tooltip>
          </div>
          <div class="">
            {{ financialAccount.uniqueLimit ?
            (financialAccount.uniqueLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
          </div>
        </div>
        <div class="row line">
          <div class="">Patrimônio Líquido Inicial</div>
          <div class=""
            [ngClass]="{'high': financialAccount.initialEquity > 0, 'low': financialAccount.initialEquity < 0 }">
            {{ financialAccount.initialEquity ?
            (financialAccount.initialEquity | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
          </div>
        </div>
        <div class="row line bg">
          <div class="">Patrimônio Líquido Online</div>
          <div class=""
            [ngClass]="{'high': financialAccount.totalEquity > 0, 'low': financialAccount.totalEquity < 0 }">
            {{ financialAccount.totalEquity ?
            (financialAccount.totalEquity | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
          </div>
        </div>
        <div class="row line">
          <div class="bold">Atualizado em: {{ dateRequest | date:'HH:mm' }}</div>
          <div class="refresh" (click)="retry()">
            <mat-icon svgIcon="retry"></mat-icon>
            <span>Atualizar</span>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #balanceProjOnlineDetail>
  <div class="row line">
    <div class="">D+0:</div>
    <div class="value">{{
      financialAccount.balanceD0 ?
      (financialAccount.balanceD0 | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="">D+1:</div>
    <div class="value">{{
      financialAccount.balanceD1 ?
      (financialAccount.balanceD1 | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="">D+2:</div>
    <div class="value">{{
      financialAccount.balanceD2 ?
      (financialAccount.balanceD2 | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
</ng-template>

<ng-template #uniqueLimitDetail>
  <div class="row line">
    <div class="text">Alavancagem BM&F</div>
    <div class="value mr-5">
      {{ financialAccount.bmfLeveragedLimit ?
      (financialAccount.bmfLeveragedLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
    <div class="text">Limite de Fundos</div>
    <div class="value">{{
      financialAccount.bmfLeveragedLimit ?
      (financialAccount.bmfLeveragedLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="text">Limite de Renda Fixa</div>
    <div class="value mr-5">
      {{ financialAccount.refiLimit ?
      (financialAccount.refiLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
    <div class="text">Limite de Tesouro Direto</div>
    <div class="value">{{
      financialAccount.tediLimit ?
      (financialAccount.tediLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="text">Limite para saque</div>
    <div class="value mr-5">
      {{ financialAccount.withdrawLimit ?
      (financialAccount.withdrawLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
    <div class="text">Saldo para saque utilizado</div>
    <div class="value">
      {{ financialAccount.withdrawLimitUsed ?
      (financialAccount.withdrawLimitUsed | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="text">Limite BM&F</div>
    <div class="value  mr-5">
      {{ financialAccount.bmfLimit ?
      (financialAccount.bmfLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
    <div class="text">Limite Opções</div>
    <div class="value">
      {{ financialAccount.optionLimit ?
      (financialAccount.optionLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
  <div class="row line">
    <div class="text">Alavancagem Vista</div>
    <div class="value mr-5">
      {{ financialAccount.cashLeveragedLimit ?
      (financialAccount.cashLeveragedLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
    <div class="text">Alavancagem opções</div>
    <div class="value">
      {{ financialAccount.optionsLeveragedLimit ?
      (financialAccount.optionsLeveragedLimit | currency:'BRL':'symbol':'1.2-2':'pt') : 'R$ 0,00' }}
    </div>
  </div>
</ng-template>
